import { defineMessages } from "react-intl";
const messages = defineMessages({
    // Headers
    rankHeader: {
        id: "app.admin.aiDiscoverability.topSources.rankHeader",
        defaultMessage: "Rank",
    },
    topSourcesHeader: {
        id: "app.admin.aiDiscoverability.topSources.topSourcesHeader",
        defaultMessage: "Top Sources",
    },
    citationWeightHeader: {
        id: "app.admin.aiDiscoverability.topSources.citationWeightHeader",
        defaultMessage: "Citation Share",
    },
    topPerformersShareHeader: {
        id: "app.admin.aiDiscoverability.topSources.topPerformersShareHeader",
        defaultMessage: "Top Performer's Mentions",
    },
    yourCitationShareHeader: {
        id: "app.admin.aiDiscoverability.topSources.yourCitationShareHeader",
        defaultMessage: "Your Mentions",
    },
    gapHeader: {
        id: "app.admin.aiDiscoverability.topSources.gapHeader",
        defaultMessage: "Gap",
    },
    statusHeader: {
        id: "app.admin.aiDiscoverability.topSources.statusHeader",
        defaultMessage: "Status",
    },
    // Summary
    summaryTitle: {
        id: "app.admin.aiDiscoverability.topSources.summaryTitle",
        defaultMessage: "Summary",
    },
    visibilityScore: {
        id: "app.admin.aiDiscoverability.topSources.visibilityScore",
        defaultMessage: "Your {provider} visibility score is",
    },
    // Tooltips
    tooltipTopSources: {
        id: "app.admin.aiDiscoverability.topSources.tooltip.topSources",
        defaultMessage: "The websites AI models reference most when answering renter questions in your market.",
    },
    tooltipCitationWeight: {
        id: "app.admin.aiDiscoverability.topSources.tooltip.citationWeight",
        defaultMessage: "The percentage of all AI citations that come from this source. Higher means more influence on what renters see.",
    },
    tooltipTopPerformersMentions: {
        id: "app.admin.aiDiscoverability.topSources.tooltip.topPerformersMentions",
        defaultMessage: "The highest number of mentions any single community received when this source was cited — your benchmark for this source.",
    },
    tooltipYourMentions: {
        id: "app.admin.aiDiscoverability.topSources.tooltip.yourMentions",
        defaultMessage: "How many times your community was mentioned when this source was cited.",
    },
    tooltipGap: {
        id: "app.admin.aiDiscoverability.topSources.tooltip.gap",
        defaultMessage: "The difference between the top performer and your mentions for this source. A negative number means you’re behind.",
    },
    topSourcesAlert: {
        id: "app.admin.aiDiscoverability.topSources.tooltip.topSourcesAlert",
        defaultMessage: "This source is a priority fix. It is of high importance and you are lagging behind the top performers performance.",
    },
});
export default messages;
